"use client";

import * as React from "react";
import { Text, SectionCard, CardTitle, CardDescription, Section, Stack } from "@/src/components";
import { InstallCommand } from "@/components/docs/install-command";

export default function DocsComponentsStack() {
  return (
    <>
      <Section>
        <div className="space-y-4">
          <Text as="h1" className="text-h2 font-bold">
            Stack
          </Text>
          <Text className="text-lg text-muted-foreground max-w-2xl">
            A layout component for arranging children in vertical or horizontal stacks with consistent spacing.
          </Text>
        </div>
      </Section>

      {/* Installation */}
      <Section>
        <SectionCard
          header={
            <>
              <CardTitle>Installation</CardTitle>
              <CardDescription>Add this component to your project</CardDescription>
            </>
          }
          contentClassName="p-6"
        >
          <InstallCommand command="npx shadcn@latest add @bluecopa-ui/stack" />
        </SectionCard>
      </Section>

      <Section>
        <SectionCard
          header={
            <>
              <CardTitle>Vertical Stack</CardTitle>
              <CardDescription>Items arranged vertically</CardDescription>
            </>
          }
          contentClassName="p-6"
        >
          <Stack orientation="vertical">
            <div className="p-4 bg-muted rounded">Item 1</div>
            <div className="p-4 bg-muted rounded">Item 2</div>
            <div className="p-4 bg-muted rounded">Item 3</div>
          </Stack>
        </SectionCard>
      </Section>

      <Section>
        <SectionCard
          header={
            <>
              <CardTitle>Horizontal Stack</CardTitle>
              <CardDescription>Items arranged horizontally</CardDescription>
            </>
          }
          contentClassName="p-6"
        >
          <Stack orientation="horizontal">
            <div className="p-4 bg-muted rounded">Item 1</div>
            <div className="p-4 bg-muted rounded">Item 2</div>
            <div className="p-4 bg-muted rounded">Item 3</div>
          </Stack>
        </SectionCard>
      </Section>

      <Section>
        <SectionCard
          header={<CardTitle>Props</CardTitle>}
          contentClassName="p-6"
        >
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b">
                <th className="text-left py-2 font-semibold">Prop</th>
                <th className="text-left py-2 font-semibold">Type</th>
                <th className="text-left py-2 font-semibold">Default</th>
                <th className="text-left py-2 font-semibold">Description</th>
              </tr>
            </thead>
            <tbody>
              <tr className="border-b">
                <td className="py-2 font-mono text-xs">orientation</td>
                <td className="py-2 font-mono text-xs text-muted-foreground">"vertical" | "horizontal"</td>
                <td className="py-2 font-mono text-xs">"horizontal"</td>
                <td className="py-2 text-muted-foreground">Stack orientation</td>
              </tr>
              <tr className="border-b">
                <td className="py-2 font-mono text-xs">size</td>
                <td className="py-2 font-mono text-xs text-muted-foreground">number</td>
                <td className="py-2 font-mono text-xs">40</td>
                <td className="py-2 text-muted-foreground">Item size in pixels</td>
              </tr>
              <tr className="border-b">
                <td className="py-2 font-mono text-xs">max</td>
                <td className="py-2 font-mono text-xs text-muted-foreground">number</td>
                <td className="py-2 font-mono text-xs">-</td>
                <td className="py-2 text-muted-foreground">Maximum visible items</td>
              </tr>
            </tbody>
          </table>
        </SectionCard>
      </Section>
    </>
  );
}
